import ChangeEmailStepper from "@common/account/ChangeEmailStepper"
import ChapterFeelingQuiz from "@common/chapters/feeling-quiz/ChapterFeelingQuiz"
import CallStudentsStepper from "@common/liveMode/CallStudentsStepper"
import CloseOutScreen from "@common/liveMode/close-out/CloseOutScreen"
import QualityClosureRedirect from "@common/liveMode/close-out/QualityClosureRedirect"
import EndSessionScreenStudent from "@common/liveMode/EndSessionScreenStudent"
import LaunchLiveScreen from "@common/liveMode/LaunchLiveScreen"
import LiveMainLayout from "@common/liveMode/LiveMainLayout"
import PreCallScreen from "@common/liveMode/PreCallScreen"
import SatisfactionScreen from "@common/liveMode/SatisfactionScreen"
import OffLiveStudentSpaceOnly from "@common/liveMode/OffLiveStudentSpaceOnly"
import TodoCheck from "@common/liveMode/TodoCheck"
import { theme } from "@common/theme/theme"
import LiveReportsScreen from "../components/liveReports/LiveReportsScreen"
import { AccountTypeScreen } from "../../auth/AccountTypeScreen"
import AuthNavigator from "../../auth/AuthNavigator"
import AvailabilitySlotsScreen from "../../auth/AvailabilitySlotsScreen"
import EmailVerifyScreen from "../../auth/EmailVerifyScreen"
import PrioritySchoolSubjectsScreen from "../../auth/PrioritizedSchoolSubjectsScreen"
import RegisterNewScreen from "../../auth/RegisterNewScreen"
import RegisterReturnScreen from "../../auth/RegisterReturnScreen"
import SubscribeRedirectScreen from "../../auth/SubscribeRedirectScreen"
import SubscribeReturnScreen from "../../auth/SubscribeReturnScreen"
import SubscribeScreen from "../../auth/SubscribeScreen"
import TutorRegisterScreen from "../../auth/TutorRegisterScreen"
import BrevetAppDownloadScreen from "../../brevet/BrevetAppDownloadScreen"
import BrevetConfirmationScreen from "../../brevet/BrevetConfirmationScreen"
import BrevetDiagnosticStep1Screen from "../../brevet/BrevetDiagnosticStep1Screen"
import BrevetDiagnosticStep2Screen from "../../brevet/BrevetDiagnosticStep2Screen"
import BrevetPricingCheckoutScreen from "../../brevet/BrevetPricingCheckoutScreen"
import BrevetRecommendationScreen from "../../brevet/BrevetRecommendationScreen"
import BrevetResumeScreen from "../../brevet/BrevetResumeScreen"
import { withBrevetFunnelProvider } from "../../brevet/context/BrevetFunnelContext"
import SummerClassScreen from "../../summer/SummerClassScreen"
import SummerDiagnosticScreen from "../../summer/SummerDiagnosticScreen"
import SummerPlanScreen from "../../summer/SummerPlanScreen"
import SummerTutorsScreen from "../../summer/SummerTutorsScreen"
import SummerConfiguratorScreen from "../../summer/SummerConfiguratorScreen"
import SummerSlotsCheckoutScreen from "../../summer/SummerSlotsCheckoutScreen"
import SummerConfirmationScreen from "../../summer/SummerConfirmationScreen"
import SummerAppDownloadScreen from "../../summer/SummerAppDownloadScreen"
import SummerResumeScreen from "../../summer/SummerResumeScreen"
import ActivationComposerWithPickers from "../components/family/ActivationComposerWithPickers"
import StageClassScreen from "../../stage/StageClassScreen"
import StageDiagnosticScreen from "../../stage/StageDiagnosticScreen"
import StageConfiguratorScreen from "../../stage/StageConfiguratorScreen"
import StagePlanScreen from "../../stage/StagePlanScreen"
import StageTutorsScreen from "../../stage/StageTutorsScreen"
import StageCheckoutScreen from "../../stage/StageCheckoutScreen"
import StageConfirmationScreen from "../../stage/StageConfirmationScreen"
import StageAppDownloadScreen from "../../stage/StageAppDownloadScreen"
import StageResumeScreen from "../../stage/StageResumeScreen"

import InscriptionClassScreen from "../../inscription/InscriptionClassScreen"
import InscriptionDiagnosticScreen from "../../inscription/InscriptionDiagnosticScreen"
import InscriptionConfigurationScreen from "../../inscription/InscriptionConfigurationScreen"
import InscriptionFormatScreen from "../../inscription/InscriptionFormatScreen"
import InscriptionCheckoutScreen from "../../inscription/InscriptionCheckoutScreen"
import InscriptionConfirmationScreen from "../../inscription/InscriptionConfirmationScreen"
import InscriptionTutorsScreen from "../../inscription/InscriptionTutorsScreen"
import InscriptionResumeScreen from "../../inscription/InscriptionResumeScreen"
import InscriptionAppDownloadScreen from "../../inscription/InscriptionAppDownloadScreen"
import FastTrackDiagnosticScreen from "../../fast-track/FastTrackDiagnosticScreen"
import FastTrackThankYouScreen from "../../fast-track/FastTrackThankYouScreen"
import FastTrackTrialConfirmationScreen from "../../fast-track/FastTrackTrialConfirmationScreen"
import FastTrackWelcomeScreen from "../../fast-track/FastTrackWelcomeScreen"
import StagePreInscriptionConfirmationScreen from "../../fast-track/StagePreInscriptionConfirmationScreen"
import DownloadAppCtaScreen from "../../new-subscription/DownloadAppCtaScreen"
import NewSubscriberPossibleSlotsScreen from "../../new-subscription/NewSubscriberPossibleSlotsScreen"
import StagePaymentScreen from "../../new-subscription/StagePaymentScreen"
import StagePaymentSuccessScreen from "../../new-subscription/StagePaymentSuccessScreen"
import CreateNewSubscriptionScreen from "../../new-subscription/v2/CreateNewSubscriptionScreen"
import InvoicePaymentScreenV2 from "../../new-subscription/v2/InvoicePaymentScreenV2"
import ParentMakeupOccurrencesScreen from "../../parent/ParentMakeupOccurrencesScreen"
import ConfirmQuizzScreen from "../../quiz/ConfirmQuizzScreen"
import NewQuizzScreen from "../../quiz/NewQuizzScreen"
import ActivityReviewScreen from "../../reviewer/ActivityReviewScreen"
import NewScoringCommentScreen from "../../reviewer/NewScoringCommentScreen"
import NewScoringRuleScreen from "../../reviewer/NewScoringRuleScreen"
import CTAScreen from "../../school-card-report/cta/CTAScreen"
import DiagnosticScreen from "../../school-card-report/diagnostic/DiagnosticScreen"
import BulletPointsSeeMoreScreen from "../../school-card-report/diagnostic/see-more/BulletPointsSeeMoreScreen"
import MotivationSeeMoreScreen from "../../school-card-report/diagnostic/see-more/MotivationSeeMoreScreen"
import PerformanceRankingScreen from "../../school-card-report/diagnostic/see-more/PerformanceRankingScreen"
import StyleSeeMoreScreen from "../../school-card-report/diagnostic/see-more/StyleSeeMoreScreen"
import ScanLoadingScreen from "../../school-card-report/scan/ScanLoadingScreen"
import ScanScreen from "../../school-card-report/scan/ScanScreen"
import Schools from "../../school/Schools"
import SchoolScreen from "../../school/SchoolScreen"
import AbsenceFormComponent from "../../student/absence/AbsenceFormComponent"
import RecoverFormComponent from "../../student/absence/RecoverFormComponent"
import JoinClassroomScreen from "../../student/account/classroom/JoinClassroomScreen"
import JoinSchoolScreen from "../../student/account/classroom/JoinSchoolScreen"
import CreateAvatarScreen from "../../student/account/CreateAvatarScreen"
import DeleteAccountScreen from "../../student/account/DeleteAccountScreen"
import MyAccountScreen from "../../student/account/MyAccountScreen"
import TrialSessionPreparationForm from "../../student/account/onboarding/preparation-form/TrialSessionPreparationForm"
import RegisterSpecialScreen from "../../student/account/onboarding/RegisterSpecialScreen"
import RegisterTrialScreen from "../../student/account/onboarding/RegisterTrialScreen"
import RegisterTrialSessionScreen from "../../student/account/onboarding/RegisterTrialSessionScreen"
import RegisterWorkshopScreen from "../../student/account/onboarding/RegisterWorkshopScreen"
import SchoolSubjectForm from "../../student/account/onboarding/SchoolSubjectForm"
import StudentEvaluationForm from "../../student/account/onboarding/StudentEvaluationForm"
import TrialOnboardingScreen from "../../student/account/onboarding/TrialOnboardingScreen"
import MyAccountTabNavigation from "../../student/account/SettingsTabNavigator"
import SponsorshipScreen from "../../student/account/SponsorshipScreen"
import MySubscriptionScreen from "../../student/account/subscription/MySubscriptionScreen"
import UpdatePasswordScreen from "../../student/account/UpdatePasswordScreen"
import AllActivities from "../../student/activity/AllActivities"
import ActivityWrapperScreen from "../../student/activity/execute/ActivityWrapperScreen"
import ActivityPresentationScreen from "../../student/activity/read/ActivityPresentationScreen"
import ActivityResultScreen from "../../student/activity/read/ActivityResultScreen"
import ArchivedActivitiesScreen from "../../student/activity/todo/ArchivedActivitiesScreen"
import NewTodoScreen from "../../student/activity/todo/NewTodoScreen"
import TodoListByChapterScreen from "../../student/activity/todo/TodoListByChapterScreen"
import ChampionIntroScreen from "../../student/champions/ChampionIntroScreen"
import ZoeIntroScreen from "../../student/champions/ZoeIntroScreen"
import LeagueHistoryScreen from "../../student/league/LeagueHistoryScreen"
import LeagueProgressScreen from "../../student/league/LeagueProgressScreen"
import ManageMaterialScreen from "../../student/material/ManageMaterialScreen"
import MaterialDetails from "../../student/material/MaterialDetails"
import ChallengeHistoryScreen from "../../student/organize/challenges/ChallengeHistoryScreen"
import NewChallengeScreen from "../../student/organize/challenges/NewChallengeScreen"
import RealizationsTabScreen from "../../student/organize/list/RealizationsTabScreen"
import StudentTabsNavigator from "../../student/organize/StudentTabsNavigator"
import MyProgressScreen from "../../student/progress/my progress/MyProgressScreen"
import MySkillSetsTabScreen from "../../student/progress/my progress/MySkillSetsTabScreen"
import SchoolAssessmentsScreen from "../../student/schoolAssessments/SchoolAssessmentsScreen"
import MyPetalsTabScreen from "../../student/shop/MyPetalsTabScreen"
import ProfilAmi from "../../student/social/ProfilFriendScreen"
import RankingTabScreen from "../../student/social/RankingTabScreen"
import ShareStatsScreen from "../../student/social/ShareStatsScreen"
import LiveSessionsListScreen from "../../student/tutoring/LiveSessionsListScreen"
import ClassroomNewChallenge from "../../teacher/classrooms/ClassroomNewChallenge"
import Classrooms from "../../teacher/classrooms/Classrooms"
import ClassroomScreen from "../../teacher/classrooms/ClassroomScreen"
import NewClassroomStepper from "../../teacher/classrooms/NewClassroomStepper"
import MotivationInterviewScreen from "../../tutor/application/motivation/InterviewScreen"
import VideoRecordingScreen from "../../tutor/application/motivation/VideoRecordingScreen"
import ApplicationPersonalInfos from "../../tutor/application/personalInfos/ApplicationPersonalInfos"
import TutorApplicationScreen from "../../tutor/application/TutorApplicationScreen"
import CompleteTutorProfileStepper from "../../tutor/home/CompleteTutorProfileStepper"
import GroupAttributionProposalScreen from "../../tutor/home/group-attribution/GroupAttributionProposalScreen"
import Interview from "../../tutor/home/interview/Interview"
import InterviewSummary from "../../tutor/home/interview/InterviewSummary"
import InterviewHistory from "../../tutor/home/InterviewHistory"
import SubstitutionProposalScreen from "../../tutor/home/substitution/SubstitutionProposalScreen"
import BrowseActivities from "../../tutor/home/tutorResources/BrowseActivites"
import TutorVideos from "../../tutor/home/tutorResources/TutorVideos"
import TutorTrainingScreen from "../../tutor/training/TutorTrainingScreen"
import TutoringInvoicesScreen from "../../tutor/invoices/TutoringInvoicesScreen"
import TutorLivesHistoryScreen from "../../tutor/lives/live-history/TutorLivesHistoryScreen"
import ManageRDVScreen from "../../tutor/lives/ManageRDVScreen"
import PrepareLiveScreen from "../../tutor/lives/PrepareLiveScreen"
import TutorNextLivesListScreen from "../../tutor/lives/TutorNextLivesListScreen"
import NewNoteScreen from "../../tutor/notes/NewNoteScreen"
import StudentNotesScreen from "../../tutor/notes/StudentNotesScreen"
import SlotUpdateScreen from "../../tutor/SlotUpdateScreen"
import StudentProfil from "../../tutor/students/StudentProfil"
import StudyMissionPrescriptionScreen from "../../tutor/study-missions/StudyMissionPrescriptionScreen"
import SamSessionScreen from "../../student/sam-sessions/SamSessionScreen"
import TutorSlotsScreen from "../../tutor/TutorSlotsScreen"
import MaDispoScreen from "../../tutor/availability/MaDispoScreen"
import ReleaseSlotsScreen from "../../tutor/availability/ReleaseSlotsScreen"
import StudentTutoringRequestUpdate from "../account/StudentTutoringRequestUpdate"
import ValidateEmailScreen from "../account/ValidateEmailScreen"
import CameraScreen from "../camera/CameraScreen"
import ParentNavigator from "../../ports/primary/ui/screens/parent/ParentNavigator"
import SummerCockpitScreen from "../components/family/summer/SummerCockpitScreen"
import InterviewReportScreen from "../interviewReports/InterviewReportScreen"
import InterviewReportsScreen from "../interviewReports/InterviewReportsScreen"
import LiveChat from "../liveMode/LiveChat"
import LiveParticipants from "../liveMode/LiveParticipants"
import BottomTabsNavigator from "../main-menu/BottomTabsNavigator"
import TchatScreen from "../messenger/ChatScreen"
import CongratsScreen from "../screens/CongratsScreen"
import StudyProgramScreen from "../studyPrograms/studyProgramScreen"
import { loginScreen, welcomeBridge } from "../../featureFlags/screenBridge"
import { LoginScreen as DsLoginScreen } from "../../ports/primary/ui/screens/auth/Login/LoginScreen"
import { LoginLinkScreen as DsLoginLinkScreen } from "../../ports/primary/ui/screens/auth/LoginLink/LoginLinkScreen"
import { ImpersonateScreen } from "../../ports/primary/ui/screens/auth/Impersonate/ImpersonateScreen"
import { ForgotPasswordScreen as DsForgotPasswordScreen } from "../../ports/primary/ui/screens/auth/ForgotPassword/ForgotPasswordScreen"
import { ResetPasswordScreen as DsResetPasswordScreen } from "../../ports/primary/ui/screens/auth/ResetPassword/ResetPasswordScreen"
import { AccountPickerScreen as DsAccountPickerScreen } from "../../ports/primary/ui/screens/auth/AccountPicker/AccountPickerScreen"
import { AccountChoiceScreen as DsAccountChoiceScreen } from "../../ports/primary/ui/screens/auth/AccountChoice/AccountChoiceScreen"
import { LoginWelcomeScreen as DsLoginWelcomeScreen } from "../../ports/primary/ui/screens/auth/LoginWelcome/LoginWelcomeScreen"
import { studentSpaceBridge } from "../../ports/primary/ui/screens/student/studentSpaceBridge"
import {
    selectTutorSpaceContext,
    tutorSpaceBridge,
    tutorSpaceRouteOptions,
} from "../../ports/primary/ui/screens/tutor/tutorSpaceBridge"
import { store } from "../../data/redux/storeConfig/store"
import { AccountTimezoneScreen } from "../../ports/primary/ui/screens/account/AccountTimezone/AccountTimezoneScreen"
import { CancelReasonScreen } from "../../ports/primary/ui/screens/parent/SubscriptionCancel/CancelReasonScreen"
import { CancelAlternativesScreen } from "../../ports/primary/ui/screens/parent/SubscriptionCancel/CancelAlternativesScreen"
import { CancelFeesScreen } from "../../ports/primary/ui/screens/parent/SubscriptionCancel/CancelFeesScreen"
import { CancelPaymentScreen } from "../../ports/primary/ui/screens/parent/SubscriptionCancel/CancelPaymentScreen"
import { CancelGoodbyeScreen } from "../../ports/primary/ui/screens/parent/SubscriptionCancel/CancelGoodbyeScreen"
import { StageProgramScreen } from "../../ports/primary/ui/screens/parent/StageProgram/StageProgramScreen"
import { LiveReportDetailsScreen } from "../../ports/primary/ui/screens/parent/LiveReports/LiveReportDetailsScreen"
import { ReferralDashboardScreen } from "../../ports/primary/ui/screens/parent/Referral/ReferralDashboardScreen"
import { ActivationLandingScreen } from "../../ports/primary/ui/screens/parent/Activation/ActivationLandingScreen"

/**
 * La connexion, sur le design system pour tout le monde (`loginScreen`). L'accueil a son pont
 * (`welcomeBridge`) : sans compte enregistré, il passe toujours à la connexion ; avec des comptes,
 * l'accueil d'aujourd'hui mène à « Qui utilise Masteur ? ».
 */
const loginScreens = {
    welcome: welcomeBridge(DsLoginWelcomeScreen, AuthNavigator),
    login: loginScreen(DsLoginScreen),
    loginLink: loginScreen(DsLoginLinkScreen),
    forgotPassword: loginScreen(DsForgotPasswordScreen),
    resetPassword: loginScreen(DsResetPasswordScreen),
    accountPicker: loginScreen(DsAccountPickerScreen),
    accountChoice: loginScreen(DsAccountChoiceScreen),
}

/**
 * Design-system visual-QA harness screens (mock data, no API).
 *
 * Built only when `__DEV__`, and their modules are `require`-d inside that branch rather than
 * imported at the top of the file: a static import would evaluate the fixtures (and the bundled
 * images they resolve at load time) in every release bundle, web included — which is how the
 * web app went blank on 20/09 with every flag off. `titles` intentionally omits `auth` — see
 * the spread site for why.
 */
/* global require */
const dsHarnessScreens = () => [
    {
        name: "ds-parent-home",
        component: require("../../dev/DsParentHomeScreen").default,
        options: {
            headerShown: false,
            headerTitle: "DS Parent Home (test)",
        },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "ds-live-sessions-list",
        component: require("../../dev/DsLiveSessionsListScreen").default,
        options: {
            headerShown: false,
            headerTitle: "DS Live Sessions List (test)",
        },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "ds-live-reports",
        component: require("../../dev/DsLiveReportsScreen").default,
        options: {
            headerShown: false,
            headerTitle: "DS Live Reports (test)",
        },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "ds-live-report-details",
        component: require("../../dev/DsLiveReportDetailsScreen").default,
        options: {
            headerShown: false,
            headerTitle: "DS Live Report Details (test)",
        },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "ds-revision-program",
        component: require("../../dev/DsRevisionProgramScreen").default,
        options: {
            headerShown: false,
            headerTitle: "DS Revision Program (test)",
        },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "ds-activity-overlays",
        component: require("../../dev/DsActivityOverlaysScreen").default,
        options: {
            headerShown: false,
            headerTitle: "DS Activity Overlays (test)",
        },
        titles: [{ main: {} }, { parent: {} }],
    },
]

/**
 * Main screens
 *
 * @type [{component: ((function({navigation: *}): *)|*), name: string, options: {animationTypeForReplace: string}}, {component: *, name: string}, {component: *, name: string}]
 */
const main = [
    // ** Main menu
    {
        name: "menu",
        titles: [
            {
                main: {
                    component: BottomTabsNavigator,
                },
            },
            {
                live: {
                    component: tutorSpaceBridge("menu", studentSpaceBridge("menu", LiveMainLayout)),
                    options: {
                        headerShown: true,
                        headerTitle: "LIVE",
                    },
                },
            },
            {
                parent: {
                    component: ParentNavigator,
                    options: {
                        headerShown: false,
                        headerTitle: "Espace parent",
                    },
                },
            },
            {
                auth: {
                    component: loginScreens.welcome,
                    options: {
                        animationTypeForReplace: "pop",
                        headerShown: false,
                        headerTitle: "Accueil",
                    },
                },
            },
            {
                parent: {
                    component: ParentNavigator,
                    options: {
                        headerShown: false,
                    },
                },
            },
        ],
    },
    // ** design-system test harness — dev builds only.
    // These render mock data and must never be routable in a shipped bundle. They are
    // also deliberately NOT given an `auth` title: a screen with `auth` in `titles` is
    // treated as public by `navigationUtils.isPublicPath`, which would make them
    // reachable logged out.
    ...(__DEV__ ? dsHarnessScreens() : []),
    // ** common
    {
        name: "pre-call",
        component: tutorSpaceBridge("pre-call", studentSpaceBridge("pre-call", PreCallScreen)),
        options: {
            headerTitle: "Rejoindre le Live",
            headerShown: false,
        },
        titles: [{ main: {} }],
    },
    {
        name: "subscribe",
        component: SubscribeScreen,
        options: {
            headerShown: false,
            headerTitle: "Abonnement",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }],
    },
    {
        name: "subscribe/possible-slots",
        component: NewSubscriberPossibleSlotsScreen,
        options: {
            headerShown: false,
            headerTitle: "Choix des créneaux possibles",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "subscribe/download-app",
        component: DownloadAppCtaScreen,
        options: {
            headerShown: false,
            headerTitle: "Télécharger l'app parent",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "subscribe/create-subscription",
        component: CreateNewSubscriptionScreen, // V2 component
        options: {
            headerShown: false,
            headerTitle: "Créer un abonnement",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "subscribe/create-subscription-v2",
        component: CreateNewSubscriptionScreen, // Keep for backwards compat
        options: {
            headerShown: false,
            headerTitle: "Créer un abonnement",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "invoice-payment",
        component: InvoicePaymentScreenV2,
        options: {
            headerShown: false,
            headerTitle: "Paiement",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // ===== Brevet self-served funnel =====
    // Entry point depuis la LP fr.masteur.com/brevet :
    //   /brevet/start?firstname=Léa&class=3eme&email=parent@x.fr
    // Chaque écran est wrappé du Provider funnel (state partagé via sessionStorage
    // entre les routes flat de React Navigation).
    {
        name: "brevet/start",
        component: withBrevetFunnelProvider(BrevetDiagnosticStep1Screen),
        options: {
            headerShown: false,
            headerTitle: "Sprint Brevet — Matières",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "brevet/diag-2",
        component: withBrevetFunnelProvider(BrevetDiagnosticStep2Screen),
        options: {
            headerShown: false,
            headerTitle: "Sprint Brevet — Diagnostic",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "brevet/reco",
        component: withBrevetFunnelProvider(BrevetRecommendationScreen),
        options: { headerShown: false, headerTitle: "Sprint Brevet — Reco" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "brevet/pricing-checkout",
        component: withBrevetFunnelProvider(BrevetPricingCheckoutScreen),
        options: {
            headerShown: false,
            headerTitle: "Sprint Brevet — Réservation",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "brevet/confirmation",
        component: withBrevetFunnelProvider(BrevetConfirmationScreen),
        options: {
            headerShown: false,
            headerTitle: "Sprint Brevet — Confirmation",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "brevet/app-download",
        component: withBrevetFunnelProvider(BrevetAppDownloadScreen),
        options: { headerShown: false, headerTitle: "Sprint Brevet — App" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // Admin-issued magic link entry: GET /brevet/resume?user=<base64email>.
    // Hydrates the funnel Context from the persisted FastTrackState and
    // navigation.replace's to the right step.
    {
        name: "brevet/resume",
        component: withBrevetFunnelProvider(BrevetResumeScreen),
        options: { headerShown: false, headerTitle: "Sprint Brevet — Reprise" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // ===== Summer self-served acquisition funnel (Cours d'été) =====
    // Entry point depuis la LP :
    //   /summer/start?submissionGUID=xxx  (ou ?firstname=&class=&email=)
    // L'état funnel vient du SummerFunnelProvider UNIQUE monté dans
    // RootNavigator (pas de wrapping par écran — source de vérité en mémoire,
    // partagée entre toutes les étapes, web et natif).
    {
        name: "summer/start",
        component: SummerClassScreen,
        options: { headerShown: false, headerTitle: "Cours d'été — Classe" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "summer/diagnostic",
        component: SummerDiagnosticScreen,
        options: {
            headerShown: false,
            headerTitle: "Cours d'été — Diagnostic",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "summer/plan",
        component: SummerPlanScreen,
        options: { headerShown: false, headerTitle: "Cours d'été — Programme" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "summer/configurator",
        component: SummerConfiguratorScreen,
        options: {
            headerShown: false,
            headerTitle: "Cours d'été — Configurateur",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Étape "aha moment tuteur humain" — entre le programme et le checkout.
        // Montre les masteurs qui correspondent au profil de l'enfant (matching
        // backend). Étape NON bloquante : le CTA route vers le checkout même en
        // cas de repli (cf. SummerTutorsScreen).
        name: "summer/tutors",
        component: SummerTutorsScreen,
        options: { headerShown: false, headerTitle: "Cours d'été — Tuteurs" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "summer/slots-checkout",
        component: SummerSlotsCheckoutScreen,
        options: {
            headerShown: false,
            headerTitle: "Cours d'été — Réservation",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "summer/confirmation",
        component: SummerConfirmationScreen,
        options: {
            headerShown: false,
            headerTitle: "Cours d'été — Confirmation",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "summer/app-download",
        component: SummerAppDownloadScreen,
        options: { headerShown: false, headerTitle: "Cours d'été — App" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // Admin-issued magic link entry: GET /summer/resume?user=<base64email>.
    // Hydrates the funnel Context from the persisted summer FastTrackState and
    // navigation.reset's to the right step. Mirrors brevet/resume.
    {
        name: "summer/resume",
        component: SummerResumeScreen,
        options: { headerShown: false, headerTitle: "Cours d'été — Reprise" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // Entrée par lien signé de l'activation self-serve : GET
    // /activation?u=<id>&p=activation&sig=<hmac>, envoyé par les comms
    // d'activation (mail + SMS). Déclaré dans les trois modes comme les écrans
    // de funnel : c'est ce qui le rend indépendant du navigateur d'onglets
    // parent, et donc insensible à l'écran blanc de /parent-subscription à froid.
    {
        name: "activation",
        component: ActivationLandingScreen,
        options: { headerShown: false, headerTitle: "Activer la suite" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // Le composeur de reprise (formule + date + créneaux + matières + classe),
    // en ÉCRAN : ouvert par la landing ci-dessus (paramètres du lien recopiés,
    // il refait son propre GET contexte) comme par le portail connecté (l'objet
    // user Redux porte déjà tout). Public pour la même raison que la landing.
    {
        name: "activation/composer",
        component: ActivationComposerWithPickers,
        options: { headerShown: false, headerTitle: "Modifier la reprise" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // ===== Inscription self-served acquisition funnel (cours réguliers) =====
    // Entrée depuis la LP : /inscription/start?submissionGUID=xxx (ou ?firstname=&class=).
    // L'état vient du InscriptionFunnelProvider UNIQUE monté dans RootNavigator.
    // Séquence : classe → diagnostic (objectif / niveau / matières) →
    // configuration (mode, créneaux, date) → tuteurs → checkout.
    // Pas d'écran programme : un programme jour par jour n'a pas de sens sur un
    // accompagnement à l'année (c'est la promesse de l'été).
    {
        name: "inscription/start",
        component: InscriptionClassScreen,
        options: { headerShown: false, headerTitle: "Inscription — Classe" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "inscription/diagnostic",
        component: InscriptionDiagnosticScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription — Diagnostic",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Étape unique où le parent compose sa formule : mode de cours,
        // créneaux (en modale), date de démarrage. Tous les montants viennent
        // du devis serveur.
        name: "inscription/configuration",
        component: InscriptionConfigurationScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription — Configuration",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Le format de cours sur sa propre page : la suite de la formule pour
        // les dossiers que le serveur y envoie (cf. FORMAT_STEP).
        name: "inscription/format",
        component: InscriptionFormatScreen,
        options: { headerShown: false, headerTitle: "Inscription — Format" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Étape « aha moment tuteur » — NON bloquante : le CTA route vers la
        // suite même en cas de repli (cf. InscriptionTutorsScreen).
        name: "inscription/tutors",
        component: InscriptionTutorsScreen,
        options: { headerShown: false, headerTitle: "Inscription — Tuteurs" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Récap + acompte 1 €. Le funnel conclut la vente ici : plus aucun
        // passage par subscribe/create-subscription.
        name: "inscription/checkout",
        component: InscriptionCheckoutScreen,
        options: { headerShown: false, headerTitle: "Inscription — Paiement" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Retour de paiement Stripe (return_url), avec `?user=` pour survivre à
        // un onglet froid après 3-D Secure.
        name: "inscription/confirmation",
        component: InscriptionConfirmationScreen,
        options: { headerShown: false, headerTitle: "Inscription — Confirmé" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Fin de parcours : « installez l'app », atteint par le CTA de la
        // confirmation. Même écran partagé que l'été, le stage et le brevet.
        name: "inscription/app-download",
        component: InscriptionAppDownloadScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription — Télécharger l'app",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Entrée par lien magique : GET /inscription/resume?user=<base64email>.
        name: "inscription/resume",
        component: InscriptionResumeScreen,
        options: { headerShown: false, headerTitle: "Inscription — Reprise" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // ===== Stage self-served acquisition funnel (catalogue-driven) =====
    // Entry point depuis la LP via /register/fast-track (lead_intent préfixé
    // `stage_` → dispatch FastTrackWelcomeScreen), ou entrée directe :
    //   /stage/start?submissionGUID=xxx  (ou ?firstname=&class=&email=)
    // Tout le contenu (nom du stage, formules, prix, horaires, dates) vient du
    // catalogue API — zéro constante front. L'état funnel vient du
    // StageFunnelProvider UNIQUE monté dans RootNavigator (pas de wrapping par
    // écran), même architecture que le funnel Cours d'été.
    {
        name: "stage/start",
        component: StageClassScreen,
        options: { headerShown: false, headerTitle: "Stage — Classe" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "stage/diagnostic",
        component: StageDiagnosticScreen,
        options: { headerShown: false, headerTitle: "Stage — Diagnostic" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "stage/configurator",
        component: StageConfiguratorScreen,
        options: { headerShown: false, headerTitle: "Stage — Composition" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "stage/plan",
        component: StagePlanScreen,
        options: { headerShown: false, headerTitle: "Stage — Programme" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        // Étape "aha moment tuteur humain" — entre le programme et le checkout.
        // Étape NON bloquante : le CTA route vers le checkout même en cas de
        // repli (cf. StageTutorsScreen).
        name: "stage/tutors",
        component: StageTutorsScreen,
        options: { headerShown: false, headerTitle: "Stage — Tuteurs" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "stage/checkout",
        component: StageCheckoutScreen,
        options: { headerShown: false, headerTitle: "Stage — Réservation" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "stage/confirmation",
        component: StageConfirmationScreen,
        options: { headerShown: false, headerTitle: "Stage — Confirmation" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "stage/app-download",
        component: StageAppDownloadScreen,
        options: { headerShown: false, headerTitle: "Stage — App" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    // Admin-issued magic link entry: GET /stage/resume?user=<base64email>.
    // Hydrates the funnel Context from the persisted stage FastTrackState and
    // navigation.reset's to the right step. Mirrors summer/resume.
    {
        name: "stage/resume",
        component: StageResumeScreen,
        options: { headerShown: false, headerTitle: "Stage — Reprise" },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "invoice-payment-v2",
        component: InvoicePaymentScreenV2, // Keep for backwards compat
        options: {
            headerShown: false,
            headerTitle: "Paiement",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "parent-makeup-occurrences",
        component: ParentMakeupOccurrencesScreen,
        options: {
            headerShown: false,
            headerTitle: "Séances de rattrapage",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "stage-payment",
        component: StagePaymentScreen,
        options: {
            headerShown: false,
            headerTitle: "Paiement stage",
        },
        titles: [{ auth: {} }, { main: {} }],
    },
    {
        name: "stage-payment-success",
        component: StagePaymentSuccessScreen,
        options: {
            headerShown: false,
            headerTitle: "Confirmation",
        },
        titles: [{ auth: {} }, { main: {} }],
    },
    {
        name: "prioritized-school-subjects",
        component: PrioritySchoolSubjectsScreen,
        options: {
            headerShown: false,
            headerTitle: "Matières prioritaires",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }],
    },
    {
        name: "availability-slots",
        component: AvailabilitySlotsScreen,
        options: {
            headerShown: false,
            headerTitle: "Disponibilités",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "subscribe/redirect",
        component: SubscribeRedirectScreen,
        options: {
            headerShown: false,
            headerTitle: "Abonnement",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "subscribe/return",
        component: SubscribeReturnScreen,
        options: {
            headerShown: false,
            headerTitle: "Abonnement",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "email/verify/:id/:hash",
        component: EmailVerifyScreen,
        options: {
            headerShown: false,
            headerTitle: "Vérification de l'email",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }],
    },
    {
        name: "r",
        component: LiveReportDetailsScreen,
        options: {
            headerShown: false,
            headerTitle: "Rapport de LIVE",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "live-reports",
        component: tutorSpaceBridge("live-reports", LiveReportsScreen),
        options: {
            headerShown: false,
            headerTitle: "Rapports de LIVE",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    // ** LIVE
    {
        name: "launch-live",
        component: LaunchLiveScreen,
        options: {
            headerShown: true,
            headerTitle: "LaunchLive",
        },
        titles: [{ live: {} }],
    },
    {
        name: "call-students-stepper",
        component: CallStudentsStepper,
        options: {
            headerShown: true,
            headerTitle: "Appeler",
        },
        titles: [{ live: {} }],
    },
    // Study Mission prescription (post-finalization, before quality closure).
    // Registered in BOTH live and main: the LiveModeFooter pushes this
    // screen while still in LIVE context (so navigation lands cleanly),
    // then disconnects from live which swaps the stack to MAIN — the
    // same-named screen exists in both, so it survives the swap with its
    // params intact.
    {
        name: "study-mission-prescription",
        component: tutorSpaceBridge("study-mission-prescription", StudyMissionPrescriptionScreen),
        options: {
            headerShown: false,
            headerTitle: "Prescrire avec Sam",
        },
        titles: [{ live: {}, main: {} }],
    },
    // Sam session (every off-live activity tap from the todo lands here — D22)
    {
        name: "sam-session",
        component: studentSpaceBridge("sam-session", SamSessionScreen),
        options: {
            headerShown: false,
            presentation: "modal",
            headerTitle: "Avec Sam",
        },
        titles: [{ main: {} }],
    },
    // Legacy route kept as a thin redirect so existing callers
    // (TutorTaskBanner, MissingLiveReportsCard, LiveModeHeader) keep working.
    // Forwards to end-session-tutor on mount.
    {
        name: "quality-closure",
        component: QualityClosureRedirect,
        options: {
            headerShown: false,
            headerTitle: "Bilan",
        },
        titles: [{ live: {}, main: {} }],
    },
    //Leave session
    {
        name: "end-session-tutor",
        component: tutorSpaceBridge("end-session-tutor", CloseOutScreen),
        options: {
            headerShown: false,
            headerTitle: "Bilan & comptes-rendus",
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "end-session-student",
        component: studentSpaceBridge("end-session-student", EndSessionScreenStudent),
        options: {
            headerShown: false,
            headerTitle: "Clôturer le LIVE",
        },
        titles: [{ live: {} }],
    },
    {
        // Le quiz de fin de séance, sur le design system seulement : poussé dans le live au moment d'en
        // sortir, gardé par la pile qui bascule, comme `live-end` qu'il précède après une clôture.
        name: "live-quiz",
        component: studentSpaceBridge("live-quiz", OffLiveStudentSpaceOnly),
        options: {
            headerShown: false,
            headerTitle: "Quiz de fin de séance",
        },
        titles: [{ live: {}, main: {} }],
    },
    // La fin du live de l'élève sur le design system, inscrite en live ET hors live : l'élève qui sort
    // pendant la clôture du tuteur reste sur son rapport quand le mode live s'éteint (le patron de
    // `study-mission-prescription`). L'ancien espace garde `end-session-student`.
    {
        name: "live-end",
        component: studentSpaceBridge("live-end", EndSessionScreenStudent),
        options: {
            headerShown: false,
            headerTitle: "Fin du LIVE",
        },
        titles: [{ live: {}, main: {} }],
    },
    {
        name: "live-satisfaction",
        component: studentSpaceBridge("live-satisfaction", SatisfactionScreen),
        options: {
            headerShown: false,
            headerTitle: "Satisfaction de l'élève",
        },
        titles: [{ main: {}, live: {} }],
    },
    // ** Tutor students
    {
        name: "student",
        component: tutorSpaceBridge("student", StudentTabsNavigator),
        options: {
            headerShown: false,
            headerTitle: "Élève",
        },
        titles: [
            { main: {} },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Élève",
                    },
                },
            },
            {
                parent: {},
            },
        ],
    },
    {
        name: "realizations",
        component: tutorSpaceBridge("realizations", studentSpaceBridge("realizations", RealizationsTabScreen)),
        options: {
            headerShown: false,
            headerTitle: "Élève",
        },
        titles: [{ main: {} }, { live: {} }, { parent: {} }],
    },
    {
        name: "student-profil",
        component: tutorSpaceBridge("student-profil", StudentProfil),
        options: {
            headerTitle: "Profil",
            headerShown: false,
        },
        titles: [
            { main: {} },
            {
                live: {
                    options: {
                        headerTitle: "Profil",
                        headerShown: true,
                    },
                },
            },
        ],
    },
    {
        name: "interview-summary",
        component: InterviewSummary,
        options: {
            headerTitle: "Relecture avant envoi",
            headerShown: false,
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "interview",
        component: Interview,
        options: {
            headerTitle: "Entretien",
            headerShown: false,
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "interviewHistory",
        component: InterviewHistory,
        options: {
            headerTitle: "Entretiens",
            headerShown: false,
        },
        titles: [
            { main: {} },
            {
                live: {
                    options: {
                        headerTitle: "Entretiens",
                        headerShown: true,
                    },
                },
            },
        ],
    },
    {
        name: "browse-activities",
        component: BrowseActivities,
        options: {
            headerTitle: "Référentiel des activités",
            headerShown: false,
        },
        titles: [
            { main: {} },
            {
                live: {
                    options: {
                        headerTitle: "Référentiel des activités",
                        headerShown: true,
                    },
                },
            },
        ],
    },
    {
        name: "videos-coaching",
        component: tutorSpaceBridge("videos-coaching", TutorVideos),
        options: {
            headerTitle: "Vidéos de formation",
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "update-occupied-slots",
        component: SlotUpdateScreen,
        options: {
            headerTitle: "Modifier un créneau",
            headerShown: false,
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "student-notes",
        component: StudentNotesScreen,
        options: {
            headerTitle: "Notes du Masteur",
            headerShown: false,
        },
        titles: [
            { main: {} },
            {
                live: {
                    options: {
                        headerTitle: "Notes du Masteur",
                        headerShown: true,
                    },
                },
            },
        ],
    },
    {
        name: "new-note",
        component: NewNoteScreen,
        options: {
            headerTitle: "Nouvelle note",
            headerShown: false,
        },
        titles: [
            { main: {} },
            {
                live: {
                    options: {
                        headerTitle: "Nouvelle note",
                        headerShown: true,
                    },
                },
            },
        ],
    },
    {
        name: "interview-reports",
        component: InterviewReportsScreen,
        options: {
            headerTitle: "Liste des entretiens parent",
            headerShown: false,
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "ir",
        component: InterviewReportScreen,
        options: {
            headerTitle: "Rapport hebdo",
            headerShown: false,
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }],
    },
    {
        name: "tutor-application",
        component: TutorApplicationScreen,
        options: {
            headerTitle: "Candidature tuteur",
            headerShown: false,
        },
        titles: [{ main: {} }],
    },
    {
        name: "application-personal-infos",
        component: tutorSpaceBridge("application-personal-infos", ApplicationPersonalInfos),
        options: {
            headerTitle: "Information personnelle",
            headerShown: false,
        },
        titles: [{ main: {} }],
    },
    {
        name: "application-interview",
        component: tutorSpaceBridge("application-interview", MotivationInterviewScreen),
        options: {
            headerTitle: "Entretien de motivation",
            headerShown: false,
        },
        titles: [{ main: {} }],
    },
    {
        name: "video-recording",
        component: tutorSpaceBridge("video-recording", VideoRecordingScreen),
        options: {
            headerTitle: "Enregistrement",
            headerShown: false,
        },
        titles: [{ main: {} }],
    },

    // ** Reviewer
    {
        name: "activity-review",
        component: ActivityReviewScreen,
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Revue d'activité",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Revue d'activité",
                    },
                },
            },
        ],
    },
    {
        name: "new-scoring-comment",
        component: NewScoringCommentScreen,
        options: {
            headerShown: false,
            headerTitle: "Nouveau commentaire",
        },
        titles: [{ main: {} }],
    },
    {
        name: "new-scoring-rule",
        component: NewScoringRuleScreen,
        options: {
            headerShown: false,
            headerTitle: "Nouvelle règle",
        },
        titles: [{ main: {} }],
    },
    // ** School
    {
        name: "schools",
        component: Schools,
        options: {
            headerTitle: "Ecoles",
            headerShown: false,
        },
        titles: [{ main: {} }],
    },
    {
        name: "school",
        component: SchoolScreen,
        options: {
            headerTitle: "École",
            headerShown: false,
        },
        titles: [{ main: {} }],
    },
    // ** Teacher
    {
        name: "new-classroom",
        component: NewClassroomStepper,
        options: {
            headerShown: false,
            headerTitle: "Nouvelle classe",
        },
        titles: [{ main: {} }],
    },
    {
        name: "classrooms",
        component: Classrooms,
        options: {
            headerShown: false,
            headerTitle: "Classes",
        },
        titles: [{ main: {} }],
    },
    {
        name: "classroom",
        component: ClassroomScreen,
        options: {
            headerShown: false,
            headerTitle: "Classe",
        },
        titles: [{ main: {} }],
    },
    {
        name: "new-challenge-classroom",
        component: ClassroomNewChallenge,
        options: {
            headerShown: false,
            headerTitle: "Nouveau défis",
        },
        titles: [{ main: {} }],
    },
    {
        name: "tutor-lives-history",
        component: tutorSpaceBridge("tutor-lives-history", TutorLivesHistoryScreen),
        options: {
            headerShown: false,
            headerTitle: "Historique des lives",
        },
        titles: [{ main: {} }],
    },
    // ** Student home
    {
        name: "my-privileges",
        component: MySubscriptionScreen,
        options: {
            headerShown: true,
            headerTitle: "Mes privilèges",
        },
        titles: [{ main: {} }],
    },
    // ** Student challenges / school subjects
    {
        name: "challenges-history",
        component: ChallengeHistoryScreen,
        titles: [
            {
                main: {
                    options: {
                        headerTitle: "Historique défis",
                        headerShown: false,
                    },
                },
            },
            {
                live: {
                    options: {
                        headerTitle: "Historique défis",
                        headerShown: true,
                    },
                },
            },
        ],
    },
    // ** Student activity
    {
        name: "activity-presentation",
        component: ActivityPresentationScreen,
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Présentation activité",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Présentation activité",
                    },
                },
            },
        ],
    },
    {
        name: "activity-result",
        component: ActivityResultScreen,
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Résultat activité",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Résultat activité",
                    },
                },
            },
        ],
    },
    {
        name: "activity",
        component: studentSpaceBridge("activity", ActivityWrapperScreen),
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Activité",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Activité",
                    },
                },
            },
            {
                parent: {
                    options: {
                        headerShown: false,
                        headerTitle: "Activité",
                    },
                },
            },
        ],
    },
    {
        name: "share-stats",
        component: ShareStatsScreen,
        options: {
            headerShown: false,
            headerTitle: "Partager mes statistiques",
        },
        titles: [{ main: {}, live: {} }],
    },

    // ** Le programme du stage acheté, que la famille adapte (espace parent seulement : un lien de
    // mail sans session attend la connexion, puis le mode parent)
    {
        name: "stage-program",
        component: StageProgramScreen,
        options: {
            headerShown: false,
            headerTitle: "Programme du stage",
        },
        titles: [{ parent: {} }],
    },
    // ** Study programs
    {
        name: "study-program",
        component: StudyProgramScreen,
        options: {
            headerShown: false,
            headerTitle: "Programme d'étude",
        },
        titles: [{ main: {}, auth: {}, parent: {} }],
    },
    // ** School Assessments
    {
        name: "school-assessments",
        component: tutorSpaceBridge("school-assessments", studentSpaceBridge("school-assessments", SchoolAssessmentsScreen)),
        options: {
            headerShown: false,
            headerTitle: "Mes contrôles",
        },
        titles: [{ main: {} }],
    },

    // ** Profile
    {
        name: "account",
        component: tutorSpaceBridge("account", studentSpaceBridge("account", MyAccountScreen)),
        options: {
            headerShown: false,
            headerTitle: "Mon compte",
        },
        titles: [{ main: {} }],
    },
    {
        name: "skill-sets",
        component: studentSpaceBridge("skill-sets", MyProgressScreen),
        options: {
            headerShown: true,
            headerTitle: "Mes quêtes",
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "ranking",
        component: studentSpaceBridge("ranking", RankingTabScreen),
        options: {
            headerShown: false,
            headerTitle: "Classement",
        },
        titles: [{ main: {} }],
    },
    {
        name: "petals",
        component: studentSpaceBridge("petals", MyPetalsTabScreen),
        options: {
            headerShown: false,
            headerTitle: "Boutique",
        },
        titles: [{ main: {} }],
    },
    {
        name: "settings",
        component: tutorSpaceBridge("settings", studentSpaceBridge("settings", MyAccountTabNavigation)),
        options: {
            headerShown: false,
            headerTitle: "Paramètres",
        },
        titles: [{ main: {} }],
    },
    {
        name: "update-slots",
        component: TutorSlotsScreen,
        options: {
            headerShown: false,
            headerTitle: "Modifier mes créneaux",
        },
        titles: [{ main: {} }],
    },
    {
        name: "tutor/formation",
        component: tutorSpaceBridge("tutor/formation", TutorTrainingScreen),
        options: {
            headerShown: false,
            headerTitle: "Ta formation",
        },
        titles: [{ main: {} }],
    },
    {
        name: "tutor/ma-dispo",
        component: tutorSpaceBridge("tutor/ma-dispo", MaDispoScreen),
        options: {
            headerShown: false,
            headerTitle: "Ma dispo",
        },
        titles: [{ main: {} }],
    },
    {
        name: "tutor/liberer-creneaux",
        component: tutorSpaceBridge("tutor/liberer-creneaux", ReleaseSlotsScreen),
        options: {
            headerShown: false,
            headerTitle: "Libérer des créneaux",
        },
        titles: [{ main: {} }],
    },
    {
        name: "tutor/complete-profile",
        component: tutorSpaceBridge("tutor/complete-profile", CompleteTutorProfileStepper),
        options: {
            headerShown: false,
            headerTitle: "Compléter mon profil tuteur",
        },
        titles: [{ main: {} }],
    },
    {
        name: "tutor/prepare-live",
        component: tutorSpaceBridge("tutor/prepare-live", PrepareLiveScreen),
        options: {
            headerShown: false,
            headerTitle: "Préparer mon live",
        },
        titles: [{ main: {} }],
    },
    {
        name: "account-password",
        component: tutorSpaceBridge("account-password", studentSpaceBridge("account-password", UpdatePasswordScreen)),
        options: {
            headerTitle: "Mot de passe",
        },
        titles: [{ main: {} }],
    },
    {
        name: "account-close",
        component: tutorSpaceBridge("account-close", studentSpaceBridge("account-close", DeleteAccountScreen)),
        options: {
            headerTitle: "Fermer mon compte",
        },
        titles: [{ main: {} }],
    },
    {
        name: "join-classroom",
        component: JoinClassroomScreen,
        options: {
            headerTitle: "Rejoindre une classe",
        },
        titles: [{ main: {} }],
    },
    {
        name: "join-school",
        component: JoinSchoolScreen,
        options: {
            headerTitle: "Rejoindre une école",
        },
        titles: [{ main: {} }],
    },
    {
        name: "sponsorship",
        component: SponsorshipScreen,
        options: {
            headerShown: false,
            headerTitle: "Parrainage",
        },
        titles: [{ main: {} }],
    },
    // ** Common
    {
        name: "camera",
        component: CameraScreen,
        options: {
            headerShown: false,
            headerTitle: "Caméra",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "messenger",
        component: tutorSpaceBridge("messenger", studentSpaceBridge("messenger", TchatScreen)),
        options: {
            headerShown: false,
            headerTitle: "Messages",
        },
        titles: [
            { main: {} },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Messages",
                    },
                },
            },
        ],
    },
    {
        name: "Profile",
        component: ProfilAmi,
        options: {
            headerShown: false,
        },
        titles: [{ main: {} }],
    },
    {
        name: "Historique",
        component: LeagueHistoryScreen,
        options: {
            headerShown: true,
        },
        titles: [{ main: {} }],
    },
    {
        name: "League_progress",
        component: LeagueProgressScreen,
        options: {
            headerShown: false,
        },
        titles: [{ main: {} }],
    },
    {
        name: "skill-set",
        component: studentSpaceBridge("skill-set", MySkillSetsTabScreen),
        options: {
            headerShown: false,
            headerTitle: "Mes quêtes",
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "shop",
        component: studentSpaceBridge("shop", MyPetalsTabScreen),
        options: {
            headerShown: false,
            headerTitle: "Boutique de gestes",
        },
        titles: [
            {
                main: {},
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Boutique de gestes",
                    },
                },
            },
        ],
    },
    {
        name: "all-activities",
        component: AllActivities,
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Toutes les activités",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Toutes les activités",
                    },
                },
            },
        ],
    },
    {
        name: "avatar",
        component: CreateAvatarScreen,
        options: {
            headerShown: true,
            headerTitle: "Personnalise ton avatar",
        },
        titles: [{ main: {} }],
    },
    {
        name: "todos-by-chapter",
        component: TodoListByChapterScreen,
        options: {
            headerShown: false,
        },
        titles: [{ main: {}, live: {} }],
    },
    {
        name: "new-todo",
        component: NewTodoScreen,
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Nouvelle activité",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Nouvelle activité",
                    },
                },
            },
        ],
    },
    {
        name: "archived-activites",
        component: tutorSpaceBridge("archived-activites", ArchivedActivitiesScreen),
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Activités archivées",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Activités archivées",
                    },
                },
            },
            {
                parent: {
                    options: {
                        headerShown: false,
                        headerTitle: "Activités archivées",
                    },
                },
            },
        ],
    },
    {
        name: "new-material",
        component: ManageMaterialScreen,
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Nouvel énoncé",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Nouvel énoncé",
                    },
                },
            },
        ],
    },
    {
        name: "update-material",
        component: ManageMaterialScreen,
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Modifier énoncé",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Modifier énoncé",
                    },
                },
            },
        ],
    },
    {
        name: "material-details",
        component: MaterialDetails,
        titles: [
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Énoncé",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Énoncé",
                    },
                },
            },
        ],
    },
    {
        name: "subscription-continuity",
        component: StudentTutoringRequestUpdate,
        options: {
            headerShown: false,
            headerTitle: "Mise à jour des besoins",
        },
        titles: [{ main: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "cancel-reason",
        component: CancelReasonScreen,
        options: { headerShown: false, headerTitle: "Résiliation" },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "cancel-alternatives",
        component: CancelAlternativesScreen,
        options: { headerShown: false, headerTitle: "Résiliation" },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "cancel-fees",
        component: CancelFeesScreen,
        options: { headerShown: false, headerTitle: "Résiliation" },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "cancel-payment",
        component: CancelPaymentScreen,
        options: { headerShown: false, headerTitle: "Résiliation" },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "cancel-goodbye",
        component: CancelGoodbyeScreen,
        options: { headerShown: false, headerTitle: "Résiliation" },
        titles: [{ main: {} }, { parent: {} }],
    },
    // « Fuseau horaire » — un écran du design system pour tous les comptes : ouvert par le
    // portail Abonnement du parent et par la ligne d'accès des réglages élève et tuteur.
    {
        name: "account-timezone",
        component: AccountTimezoneScreen,
        options: { headerShown: false, headerTitle: "Fuseau horaire" },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "referrer/dashboard",
        component: ReferralDashboardScreen,
        options: {
            headerShown: false,
            headerTitle: "Mes affiliations",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "referrer/dashboard/:h",
        component: ReferralDashboardScreen,
        options: {
            headerShown: false,
            headerTitle: "Mes affiliations",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "next-lives",
        component: TutorNextLivesListScreen,
        options: {
            headerShown: false,
            headerTitle: "Mes prochains Lives",
        },
        titles: [{ main: {} }],
    },
    // La semaine des lives du tuteur, l'ancienne modale « Voir tous » de l'accueil devenue une route.
    // Interrupteur éteint (ou tant que son lot n'a rien inscrit), l'ancienne liste des prochains lives.
    {
        name: "tutor/lives",
        component: tutorSpaceBridge("tutor/lives", TutorNextLivesListScreen),
        options: {
            headerShown: false,
            headerTitle: "Mes prochains Lives",
        },
        titles: [{ main: {} }],
    },
    {
        name: "move-session",
        component: tutorSpaceBridge("move-session", ManageRDVScreen),
        // Lues quand la pile construit ses écrans : sous l'espace tuteur, la feuille se pose par-dessus
        // l'écran d'origine ; éteint, l'ancien écran garde sa page pleine.
        options: () => ({
            headerShown: false,
            headerTitle: "Déplacer live",
            ...tutorSpaceRouteOptions("move-session", selectTutorSpaceContext(store.getState())),
        }),
        titles: [{ main: {} }],
    },
    {
        name: "absence-form",
        component: AbsenceFormComponent,
        options: {
            headerShown: false,
            headerTitle: "Signaler une absence",
        },
        titles: [{ main: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "recover-absence",
        component: RecoverFormComponent,
        options: {
            headerShown: false,
            headerTitle: "Rattraper une absence",
        },
        titles: [{ main: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "live-sessions-list",
        component: studentSpaceBridge("live-sessions-list", LiveSessionsListScreen),
        options: {
            headerShown: false,
            headerTitle: "Tous mes lives",
        },
        titles: [{ main: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "quizz",
        component: NewQuizzScreen,
        options: {
            headerShown: false,
            headerTitle: "Lancer un quiz",
        },
        titles: [{ main: {} }, { auth: {} }],
    },
    {
        name: "quizz-confirm",
        component: ConfirmQuizzScreen,
        options: {
            headerShown: false,
            headerTitle: "Lancer un quiz",
        },
        titles: [{ main: {} }, { auth: {} }],
    },
    {
        name: "offer-essential",
        component: TrialOnboardingScreen,
        options: {
            headerShown: false,
            headerTitle: "Offre Essentielle",
        },
        titles: [{ main: {} }],
    },
    {
        name: "start-trial",
        component: RegisterTrialSessionScreen,
        options: {
            headerShown: false,
            headerTitle: "Essai gratuit",
        },
        titles: [{ main: {} }],
    },
    {
        name: "trial-student-evaluation",
        component: StudentEvaluationForm,
        options: {
            headerShown: false,
            headerTitle: "évaluation",
        },
        titles: [{ main: {} }, { auth: {} }],
    },
    {
        name: "trial-school-subjects",
        component: SchoolSubjectForm,
        options: {
            headerShown: false,
            headerTitle: "",
        },
        titles: [{ main: {} }, { auth: {} }],
    },
    {
        name: "trial-preparation-form",
        component: TrialSessionPreparationForm,
        options: {
            headerShown: false,
            headerTitle: "",
        },
        titles: [{ main: {} }, { auth: {} }],
    },
    {
        name: "start-trial/confirm",
        component: RegisterTrialScreen,
        options: {
            headerShown: false,
            headerTitle: "Essai gratuit",
        },
        titles: [{ main: {} }],
    },
    {
        name: "validate-email",
        component: tutorSpaceBridge("validate-email", studentSpaceBridge("validate-email", ValidateEmailScreen)),
        options: {
            headerShown: false,
            headerTitle: "Validation email",
        },
        titles: [{ main: {} }],
    },
    {
        name: "edit-email",
        component: tutorSpaceBridge("edit-email", ChangeEmailStepper),
        options: {
            headerShown: false,
            headerTitle: "Modifier email",
        },
        titles: [{ main: {} }],
    },
    {
        name: "intro-zoe",
        component: ZoeIntroScreen,
        options: {
            headerShown: false,
            headerTitle: "Introduction",
        },
        titles: ["studentFirstChallenge"],
    },
    {
        name: "new-challenge",
        component: NewChallengeScreen,
        options: {
            headerShown: true,
            headerTitle: "Nouveau défi",
        },
        titles: [
            "studentFirstChallenge",
            {
                main: {
                    options: {
                        headerShown: false,
                        headerTitle: "Nouveau défi",
                    },
                },
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Nouveau défi",
                    },
                },
            },
        ],
    },
    {
        name: "presence",
        component: LiveParticipants,
        options: {
            headerShown: false,
            headerTitle: "LIVE",
        },
        titles: [{ live: {} }],
    },
    {
        name: "messages",
        component: LiveChat,
        options: {
            headerShown: false,
            headerTitle: "LIVE Messages",
        },
        titles: [{ live: {} }],
    },
    {
        name: "summer-cockpit",
        component: SummerCockpitScreen,
        options: {
            headerShown: false,
            headerTitle: "Été 2026",
        },
        titles: [{ main: {} }, { parent: {} }],
    },
    {
        name: "school-card-report",
        component: ScanScreen,
        options: {
            headerShown: false,
            detachPreviousScreen: false,
        },
        titles: [{ main: {}, auth: {} }],
    },
    {
        name: "school-card-report/loading",
        component: ScanLoadingScreen,
        options: {
            headerShown: false,
            detachPreviousScreen: false,
        },
        titles: [{ main: {}, auth: {} }],
    },
    {
        name: "school-card-report/diagnostic",
        component: DiagnosticScreen,
        options: {
            headerShown: false,
            detachPreviousScreen: false,
        },
        titles: [{ main: {}, auth: {} }],
    },
    {
        name: "school-card-report/diagnostic/performance/ranking",
        component: PerformanceRankingScreen,
        options: {
            headerShown: false,
            detachPreviousScreen: false,
        },
        titles: [{ main: {}, auth: {} }],
    },
    {
        name: "school-card-report/diagnostic/motivation/see-more",
        component: MotivationSeeMoreScreen,
        options: {
            headerShown: false,
            detachPreviousScreen: false,
        },
        titles: [{ main: {}, auth: {} }],
    },
    {
        name: "school-card-report/diagnostic/style/see-more",
        component: StyleSeeMoreScreen,
        options: {
            headerShown: false,
            detachPreviousScreen: false,
        },
        titles: [{ main: {}, auth: {} }],
    },
    {
        name: "school-card-report/diagnostic/bullet-points/see-more",
        component: BulletPointsSeeMoreScreen,
        options: {
            headerShown: false,
            detachPreviousScreen: false,
        },
        titles: [{ main: {}, auth: {} }],
    },
    {
        name: "school-card-report/cta",
        component: CTAScreen,
        options: {
            headerShown: false,
            detachPreviousScreen: false,
        },
        titles: [{ main: {}, auth: {} }],
    },
    {
        name: "account-type",
        component: AccountTypeScreen,
        options: {
            headerShown: false,
            headerTitle: "Créer un compte",
        },
        titles: [{ auth: {} }],
    },
    {
        name: "register-tutor",
        component: TutorRegisterScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription",
        },
        titles: [{ auth: {} }],
    },

    // `/login`, identifier first: phone → SMS code, or email → code or
    // password. Emails and the welcome of a device with no account all point here.
    {
        name: "login",
        component: loginScreens.login,
        options: {
            headerShown: false,
            headerTitle: "Connexion",
        },
        titles: [{ auth: {} }],
    },
    // The same screen on its email step (code or password), for links that
    // already know the email.
    {
        name: "login/password",
        component: loginScreens.login,
        options: {
            headerShown: false,
            headerTitle: "Connexion",
        },
        titles: [{ auth: {} }],
    },
    // Former address of « Recevoir un code »: an open tab or a bookmark
    // still lands on the login.
    {
        name: "login-code",
        component: loginScreens.login,
        options: {
            headerShown: false,
            headerTitle: "Connexion",
        },
        titles: [{ auth: {} }],
    },
    {
        name: "login-link",
        component: loginScreens.loginLink,
        options: {
            headerShown: false,
            headerTitle: "Connexion",
        },
        // The email's « Me connecter » link must also work logged in (same
        // account → home, other account → switch), so every stack has it.
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "impersonate",
        component: ImpersonateScreen,
        options: {
            headerShown: false,
            headerTitle: "Impersonation",
        },
        // Reachable from every stack so /impersonate?code=… can mount even
        // when the persisted session is already in parent mode (re-impersonation).
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "family-account-selection",
        component: loginScreens.accountPicker,
        options: {
            headerShown: false,
            headerTitle: "Choisir un compte",
        },
        titles: [{ auth: {} }],
    },
    {
        name: "account-choice",
        component: loginScreens.accountChoice,
        options: {
            headerShown: false,
            headerTitle: "Ajouter un compte",
        },
        titles: [{ auth: {} }],
    },
    {
        name: "register",
        component: RegisterNewScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription",
        },
        // deepLinkConfig: {
        //     platform: "web&mobile",
        //     downloadRequired: false,
        //     downloadBanner: false,
        // },
        titles: [{ auth: {} }],
    },
    {
        name: "register/fast-track",
        component: FastTrackWelcomeScreen,
        options: {
            headerShown: false,
            headerTitle: "Confirmation",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "register/fast-track/diagnostic",
        component: FastTrackDiagnosticScreen,
        options: {
            headerShown: false,
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "register/fast-track/thank-you",
        component: FastTrackThankYouScreen,
        options: {
            headerShown: false,
            headerTitle: "Merci !",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "register/fast-track/confirm-trial",
        component: FastTrackTrialConfirmationScreen,
        options: {
            headerShown: false,
            headerTitle: "Confirmation de la séance",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "register/fast-track/stage-confirmation",
        component: StagePreInscriptionConfirmationScreen,
        options: {
            headerShown: false,
            headerTitle: "Pré-inscription confirmée",
        },
        titles: [{ auth: {} }, { main: {} }, { parent: {} }],
    },
    {
        name: "register-trial",
        component: RegisterTrialSessionScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription",
        },
        titles: [
            { auth: {} },
            {
                menu: {
                    component: RegisterReturnScreen,
                },
            },
        ],
    },
    {
        name: "register-holidays",
        component: RegisterTrialSessionScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription vacances",
        },
        titles: [
            { auth: {} },
            {
                menu: {
                    component: RegisterReturnScreen,
                },
            },
        ],
    },
    {
        name: "register-special",
        component: RegisterSpecialScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription Live Spécial",
        },
        titles: [{ auth: {} }, { menu: {} }],
    },
    {
        name: "register-workshop",
        component: RegisterWorkshopScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription Live Atelier",
        },
        titles: [{ auth: {} }, { menu: {} }],
    },
    {
        name: "register-trial/confirm",
        component: RegisterTrialScreen,
        options: {
            headerShown: false,
            headerTitle: "Inscription",
        },
        titles: [{ auth: {} }],
    },
    {
        name: "reset-password",
        component: loginScreens.forgotPassword,
        options: {
            headerShown: true,
            headerTitle: "Mot de passe oublié",
        },
        titles: [{ auth: {} }],
    },
    {
        name: "password/reset/:passwordToken",
        component: loginScreens.resetPassword,
        options: {
            headerShown: false,
            headerTitle: "Nouveau mot de passe",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }],
    },
    {
        name: "congrats",
        component: studentSpaceBridge("congrats", CongratsScreen),
        options: {
            headerShown: false,
            headerTitle: "Félicitations",
            cardStyle: { backgroundColor: theme.colors.white },
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }, { parent: {} }],
    },
    {
        name: "feeling",
        component: ChapterFeelingQuiz,
        options: {
            headerShown: false,
            headerTitle: "Questionnaire",
            cardStyle: { backgroundColor: theme.colors.white },
        },
        titles: [{ main: {} }, { live: {} }],
    },
    {
        name: "todo-check",
        component: TodoCheck,
        options: {
            headerShown: false,
            headerTitle: "Vérification avant clôture",
            cardStyle: { backgroundColor: theme.colors.white },
        },
        titles: [{ live: {} }],
    },
    {
        name: "intro",
        component: tutorSpaceBridge("intro", ChampionIntroScreen),
        options: {
            headerShown: false,
            headerTitle: "Introduction",
        },
        titles: [
            {
                main: {},
            },
            {
                live: {
                    options: {
                        headerShown: true,
                        headerTitle: "Introduction",
                    },
                },
            },
            { auth: {} },
        ],
    },
    {
        name: "tutoring-invoices",
        component: tutorSpaceBridge("tutoring-invoices", TutoringInvoicesScreen),
        options: {
            headerShown: false,
            headerTitle: "Factures",
        },
        titles: [{ main: {} }],
    },
    {
        name: "substitution-proposals",
        component: tutorSpaceBridge("substitution-proposals", SubstitutionProposalScreen),
        options: {
            headerShown: false,
            headerTitle: "Demande de remplacement",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }],
    },
    {
        name: "group-attribution-proposals",
        component: tutorSpaceBridge("group-attribution-proposals", GroupAttributionProposalScreen),
        options: {
            headerShown: false,
            headerTitle: "Proposition d'attribution de groupe",
        },
        titles: [{ main: {} }, { live: {} }, { auth: {} }],
    },
    {
        name: "student-tutoring-request-update",
        component: StudentTutoringRequestUpdate,
        options: {
            headerShown: false,
            headerTitle: "Mise à jour des besoins",
        },
        titles: [{ main: {} }, { auth: {} }],
    },
]

export const navigationScreens = {
    main,
}
